import { PropsWithChildren } from 'react';
import { ErrorBoundary as REB } from 'react-error-boundary';
import ErrorFallback from './error-fallback';
import errorHandler from './error-handler';

export function ErrorBoundary({ children }: PropsWithChildren<Record<string, unknown>>) {
  return (
    <REB FallbackComponent={ErrorFallback} onError={errorHandler}>
      {children}
    </REB>
  );
}
